import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IGeneratePinEntity, IGeneratePinReqBody } from '../../../entity';

export interface IGeneratePinUseCase {
    execute(reqBody: IGeneratePinReqBody): Promise<IGeneratePinEntity>;
}

export class GeneratePinUseCase implements IGeneratePinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(reqBody: IGeneratePinReqBody): Promise<IGeneratePinEntity> {
        return await this.userRepo.generatePin(reqBody);
    }
}
